module.exports = __webpack_public_path__ + "static/media/wgs_card.c6ccaf94.png";